import React from "react";
import Filter from '../../../components/CRM/Filter';
import TextInput from "../../../components/CRM/TextInput";
import DateInput from "../../../components/CRM/DateInput";
import SelectInput from "../../../components/CRM/SelectInputType";

const betItems = [
  {id: "stryktipset", name: "Stryktipset"},
  {id: "europatipset", name: "Europatipset"},
  {id: "v75", name: "V75"},
  {id: "v86", name: "V86"}
];

const VirtualSlipFilter = props => (
  <Filter {...props}>
    <TextInput label="resources.virtualSlips.search" source="store_name_like" />

    <SelectInput
      label="resources.virtualSlips.inputs.betType"
      source="type_like"
      choices={betItems}
      translateChoice={false}
      allowEmpty={false}
    />

    <TextInput
      label="resources.virtualSlips.fields.expert"
      source="expert_like"
    />

    <DateInput
      label="resources.virtualSlips.fields.startDate"
      source="start_date_on_date"
    />
    <DateInput
      label="resources.virtualSlips.fields.closingTime"
      source="closing_time_on_date"
    />
    <TextInput label="resources.virtualSlips.fields.link" source="short_url" />
    <DateInput
      label="resources.virtualSlips.fields.createdAt"
      source="created_at_on_date"
    />
  </Filter>
);

export default VirtualSlipFilter;



// WEBPACK FOOTER //
// ./src/containers/CRM/VirtualSlips/VirtualSlipFilter.js